import PropTypes from "prop-types";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { TabContainer } from "./Tab.styles";
import { Button } from "components/Button";

const Tabs = ({
  options,
  handleTabClick,
  isDisabled = false,
  showDivider = true,
  tabSearchKey = "activeTab",
  appendParams = true,
  // Whether the other query params survive a tab switch. Pages that keep
  // per-tab state (filters, page) in the URL pass false so it does not bleed
  // into the next tab.
  keepParams = true,
  children,
}) => {
  let [searchParams, setSearchParams] = useSearchParams();

  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    let activeTab = searchParams.get(tabSearchKey);
    if (!activeTab) {
      activeTab = options[0].key;
    }
    setActiveTab(activeTab);

    if (handleTabClick) {
      handleTabClick({ key: activeTab });
    }
  }, [searchParams.get(tabSearchKey)]);

  const handleTabSwitch = (filter) => {
    if (appendParams) {
      const queryParam = keepParams
        ? Object.fromEntries([...searchParams])
        : {};
      setSearchParams({ ...queryParam, [tabSearchKey]: filter.key });
    }

    setActiveTab(filter.key);
    handleTabClick(filter);
  };

  const getIcon = ({ ActiveIcon, Icon, ...filter }) => {
    if (activeTab == filter.key && ActiveIcon) {
      return <ActiveIcon className={filter.iconClass} />;
    }
    return (
      <span className={filter.iconClass}>
        <Icon />
      </span>
    );
  };

  return (
    <TabContainer className="tab-container">
      <div className="tab-wrapper">
        <div className="tabs">
          {options?.map((filter) => (
            <Button
              key={filter.key}
              disabled={filter.isDisabled || isDisabled}
              onClick={() => handleTabSwitch(filter)}
              className={classNames("btn-filter", {
                active: activeTab === filter.key,
              })}
            >
              {filter?.Icon && getIcon(filter)}
              {filter.name}
              {filter?.Tag && <filter.Tag />}
            </Button>
          ))}
        </div>
        {children}
      </div>
      {showDivider && <div className="divider" />}
    </TabContainer>
  );
};

Tabs.propTypes = {
  options: PropTypes.array,
  handleTabClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  showDivider: PropTypes.bool,
  children: PropTypes.node,
  tabSearchKey: PropTypes.string,
  appendParams: PropTypes.bool,
  keepParams: PropTypes.bool,
};

export { Tabs };
